import clsx from 'clsx'

export default function VideoControls({
  isVideoEnabled,
  isAudioEnabled,
  isRecording,
  isInterviewer,
  onToggleVideo,
  onToggleAudio,
  onStartRecording,
  onStopRecording,
  onToggleTranscript,
  onEndCall,
  className,
}) {
  const buttonBaseClasses = clsx(
    'control-btn',
    'group relative'
  )

  const labelClasses = 'control-label'

  return (
    <div className={clsx('flex justify-center items-center gap-4 relative z-[100] flex-wrap min-h-[90px]', className)}>
      {/* Media Controls */}
      <div className="control-group">
        <button
          className={clsx(
            buttonBaseClasses,
            !isVideoEnabled && 'muted'
          )}
          onClick={onToggleVideo}
          title={isVideoEnabled ? 'Turn off camera' : 'Turn on camera'}
        >
          <span className="relative z-10">{isVideoEnabled ? '📹' : '📹'}</span>
          <span className={labelClasses}>
            {isVideoEnabled ? 'Camera' : 'Camera Off'}
          </span>
        </button>

        <button
          className={clsx(
            buttonBaseClasses,
            !isAudioEnabled && 'muted'
          )}
          onClick={onToggleAudio}
          title={isAudioEnabled ? 'Mute' : 'Unmute'}
        >
          <span className="relative z-10">{isAudioEnabled ? '🎤' : '🔇'}</span>
          <span className={labelClasses}>
            {isAudioEnabled ? 'Microphone' : 'Muted'}
          </span>
        </button>
      </div>

      {/* Recording Controls (Interviewer only) */}
      {isInterviewer && (
        <div className="control-group" id="recordingControls">
          {!isRecording ? (
            <button
              className={buttonBaseClasses}
              onClick={onStartRecording}
              title="Start recording"
            >
              <span className="relative z-10">⏺️</span>
              <span className={labelClasses}>Start</span>
            </button>
          ) : (
            <button
              className={clsx(buttonBaseClasses, 'recording')}
              onClick={onStopRecording}
              title="Stop recording"
            >
              <span className="relative z-10">⏹️</span>
              <span className={labelClasses}>Stop</span>
            </button>
          )}
        </div>
      )}

      {/* Transcript Toggle */}
      {/*
      <div className="control-group">
        <button
          className={buttonBaseClasses}
          onClick={onToggleTranscript}
          title="Toggle transcript"
        >
          <span className="relative z-10">💬</span>
          <span className={labelClasses}>Transcript</span>
        </button>
      </div>
      */}

      {/* End Call */}
      <div className="control-group">
        <button
          className={clsx(buttonBaseClasses, 'end-call-btn')}
          onClick={onEndCall}
          title="End call"
        >
          <span className="relative z-10">📞</span>
          <span className={labelClasses}>End Call</span>
        </button>
      </div>
    </div>
  )
}
